import { Component, Vue, Inject } from "vue-property-decorator";
import nyNetwork from "@/api/nyBaseNetwork";
import DZModelLink from "@/views/系统设置/model/DZModelLink";

@Component({
    components: {}
})

export default class Index extends Vue {

    $refs: any;

    table_height = 0;

    is_dialog_show = false;

    m_link = new DZModelLink();

    list_link :Array<DZModelLink> = []

    created() {
        this.action_list_data()
    }

    mounted() {
        this.$nextTick(() => {
            const mainHeight = this.$refs.mainContent.offsetHeight;
            const mainScreen = this.$refs.mainScreen.offsetHeight;
            this.table_height = mainHeight - mainScreen - 50;
        })
    }

    action_list_data(){
        nyNetwork.net("链接列表",{},res => {
            this.list_link = res
        })
    }

    handle_add(){
        this.m_link = new DZModelLink();
        this.is_dialog_show = true
    }

    dialog_close(){
        this.m_link = new DZModelLink();
        this.is_dialog_show = false
    }

    handle_submit(){
        nyNetwork.net("链接编辑",this.m_link,res => {
            this.is_dialog_show = false
            this.action_list_data()
        })
    }

    handle_edit(row){
        this.m_link = JSON.parse(JSON.stringify(row))
        this.is_dialog_show = true
    }

    handle_delete(row){
        nyNetwork.net("链接删除",row,res => {
            this.action_list_data()
        })
    }
}
